import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DeviceService } from '../../../device.service';

@Component({
	selector: 'app-power-study-header-report',
	templateUrl: './power-study-header-report.component.html',
	styleUrls: ['./power-study-header-report.component.css']
})
export class PowerStudyHeaderReportComponent {
	constructor(public deviceService: DeviceService,
	){}

	@Input() device: any = {};
	@Input() studyInfo: any;
	@Input() siteInfo: any = {};
	@Input() selectedPeriodFormatted!: string;

}
